export { PrayerPreText } from './prayer-pre-text';
